import React from 'react';
import { ATMGrid, ATMHeader, ATMSegment } from 'shared-it-appmod-ui';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import Lang from 'src/libraries/language';
import { IRequest } from 'src/models/request.model';

type IProps = {
  data: IRequest;
};

const FlightRequestRequestor: React.FC<IProps> = ({ data: { request } }) => {
  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_REQUEST_REQUESTOR_INFORMATION}</ATMHeader>
      <ATMGrid columns={2}>
        <ATMGrid.Column>
          <FieldReadOnly label={Lang.LBL_NAME} inline>
            {request.requestorName}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_ID} inline>
            {request.requestorNo}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_DEPARTMENT} inline>
            {request.requestorDept}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_JOB_TITLE} inline>
            {request.requestorJobTitle}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMAIL} inline>
            {request.requestorEmail}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_REQUEST_REQUESTOR_CONTACT} inline>
            {request.requestorPhone}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_MGR_NAME} inline>
            {request.managerName}
          </FieldReadOnly>
          <FieldReadOnly label={Lang.LBL_EMPLOYEE_MGR_E_MAIL} inline>
            {request.managerEmail}
          </FieldReadOnly>
        </ATMGrid.Column>
      </ATMGrid>

      <ATMHeader>{Lang.TTL_REQUEST_REQUESTOR_FEILD_CONTACT}</ATMHeader>
      {request.fieldContactFlag === false ? (
        <>
          <ATMGrid columns={2}>
            <ATMGrid.Column>
              <FieldReadOnly label={Lang.LBL_REQUEST_FIELD_CONTACT_NAME} inline>
                {request.fieldName}
              </FieldReadOnly>
              <FieldReadOnly label={Lang.LBL_REQUEST_COMPANY} inline>
                {request.fieldCompany}
              </FieldReadOnly>
              <FieldReadOnly label={Lang.LBL_REQUEST_CONTACT} inline>
                {request.fieldPhone}
              </FieldReadOnly>
            </ATMGrid.Column>
          </ATMGrid>
        </>
      ) : (
        <p style={{ fontStyle: 'italic' }}>
          {Lang.TTL_REQUESTOR_IS_FIELD_CONTACT}
        </p>
      )}
    </ATMSegment>
  );
};

export default FlightRequestRequestor;
